let activeLocks = 0;
let restorePage;

// Shared by nested overlays: only the final dismissal restores the viewport.
export function lockPageScroll() {
  if (activeLocks === 0) {
    const root = document.documentElement;
    const body = document.body;
    const pageUrl = window.location.href;
    const x = window.scrollX;
    const y = window.scrollY;
    const saved = [];
    const set = (element, property, value) => {
      saved.push({ element, property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property) });
      element.style.setProperty(property, value, 'important');
    };
    const scrollbar = Math.max(0, window.innerWidth - root.clientWidth);
    if (scrollbar) {
      set(body, 'padding-right', `${(parseFloat(window.getComputedStyle(body).paddingRight) || 0) + scrollbar}px`);
    }
    // Preserve normal document flow; fixing this site's 100vh body clips content.
    set(root, 'overflow', 'hidden');
    set(root, 'overscroll-behavior', 'none');

    restorePage = () => {
      const behavior = root.style.getPropertyValue('scroll-behavior');
      const priority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      try {
        saved.reverse().forEach(({ element, property, value, priority: savedPriority }) => {
          if (value) element.style.setProperty(property, value, savedPriority);
          else element.style.removeProperty(property);
        });
        // Let route navigation own its new scroll position.
        if (window.location.href === pageUrl) window.scrollTo(x, y);
      } finally {
        if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
        else root.style.removeProperty('scroll-behavior');
      }
    };
  }
  activeLocks += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeLocks -= 1;
    if (activeLocks === 0) {
      restorePage();
      restorePage = undefined;
    }
  };
}
